import { render, staticRenderFns } from "./InsuranceTypesUpdate.vue?vue&type=template&id=faa32c3a"
import script from "./InsuranceTypesUpdate.vue?vue&type=script&lang=js"
export * from "./InsuranceTypesUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports